<template>
  <div class="container">
    <NewQuestion
      v-if="newQuestionForm"
      style="margin-top: var(--spacing-md);" :question="questionEdit" mode="edit"
      :type="$route.name === 'question-question' ? 'main' : 'in-video'"
    />
    <QuestionDetails
      v-else
      :key="questionKey"
      :count-answers="questionInfo.answers ? questionInfo.answers.length : 0"
      :count-helpful-answers="questionInfo.answers ? questionInfo.answers.filter(a => a.helpful).length : 0"
      :question-info="questionInfo"
      :type="$route.name === 'question-question' ? 'main' : 'in-video'"
      @refreshquestion="refreshQuestion"
      @editquestion="editQuestion"
    />
  </div>
</template>

<script>
import QuestionDetails from '@itbpbg/lms-components/src/Qa/QuestionDetails.vue';

export default {
  components: {
    QuestionDetails,
    NewQuestion: async () => import('@itbpbg/lms-components/src/Qa/NewQuestion'),
  },
  async asyncData({ $axios, route, error }) {
    const questionInfo = await $axios.$get(
      `/qa-hub/questions/${route.params.question}`,
    ).catch(() => false);

    if (!questionInfo) {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    return {
      questionInfo,
      newQuestionForm: false,
      questionKey: -1,
      questionEdit: {
        title: '',
        body: '',
        url: '',
        courseSlug: '',
      },
    };
  },
  head() {
    return {
      titleTemplate: this.questionInfo
        ? `${this.questionInfo.title}%s`
        : 'Question%s',
    };
  },
  mounted() {
    this.$root.$off('loadquestion');
    this.$root.$on('loadquestion', async (url) => {
      this.newQuestionForm = false;
      this.questionInfo = await this.$axios.$get(`/qa-hub/questions/${url}`);
      this.questionKey = this.questionInfo.id;
    });
  },
  methods: {
    async refreshQuestion(questionUrl) {
      this.questionInfo = await this.$axios.$get(
        `/qa-hub/questions/${questionUrl}`,
      );
      this.questionKey = 1;
    },
    editQuestion(questionEdit) {
      this.newQuestionForm = true;
      this.questionEdit = questionEdit;
    },
  },
};
</script>
